import { InventoryService } from '../../../../../../services/inventory-service';
import messages from '../../messages';

const available = messages.available.defaultMessage.toLowerCase().trim();
const onHand = messages.onHand.defaultMessage.toLowerCase().trim();
const blankBox = messages.blankBox.defaultMessage.toLowerCase().trim();

const MappedStockLevelLabels = {
  [available]: InventoryService.StockLevelQuantityType.Available,
  [onHand]: InventoryService.StockLevelQuantityType.Total,
  [blankBox]: InventoryService.StockLevelQuantityType.BlankBox,
};

export const attemptToMapStockLevels = (stockLevels) => {
  const mappedStockLevels = stockLevels.reduce((acc, stockLevel) => {
    const { label } = stockLevel;
    const formattedLabel = label?.toLowerCase().trim();

    const mappedType = MappedStockLevelLabels[formattedLabel];

    if (mappedType) {
      acc.push({
        ...stockLevel,
        mappedType,
      });
    }

    return acc;
  }, []);

  return mappedStockLevels;
};

export const getMappedStockLevels = (stockLevels) => {
  const mappedStockLevels = attemptToMapStockLevels(stockLevels);

  if (!mappedStockLevels.length) {
    return { didSucceed: false };
  }

  const availableStock = mappedStockLevels.find((stockLevel) => {
    return stockLevel.mappedType === InventoryService.StockLevelQuantityType.Available;
  });
  const totalStock = mappedStockLevels.find((stockLevel) => {
    return stockLevel.mappedType === InventoryService.StockLevelQuantityType.Total;
  });
  const blankBoxStock = mappedStockLevels.find((stockLevel) => {
    return stockLevel.mappedType === InventoryService.StockLevelQuantityType.BlankBox;
  });

  return {
    didSucceed: true,
    availableStock,
    totalStock,
    blankBoxStock,
  };
};
